var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "current",
    viewBox: "0 0 60 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_464",
    "data-name": "\\uADF8\\uB8F9 464",
    transform: "translate(-1248 -829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_39",
    "data-name": "\\uD328\\uC2A4 39",
    d: "M10,2a8.009,8.009,0,0,0-8,8V35a8.009,8.009,0,0,0,8,8H50a8.009,8.009,0,0,0,8-8V10a8.009,8.009,0,0,0-8-8H10m0-2H50A10,10,0,0,1,60,10V35A10,10,0,0,1,50,45H10A10,10,0,0,1,0,35V10A10,10,0,0,1,10,0Z",
    transform: "translate(1248 829)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_237",
    "data-name": "\\uC0AC\\uAC01\\uD615 237",
    width: 6,
    height: 12,
    rx: 3,
    transform: "translate(1266 855)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_238",
    "data-name": "\\uC0AC\\uAC01\\uD615 238",
    width: 6,
    height: 16,
    rx: 3,
    transform: "translate(1276 851)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_239",
    "data-name": "\\uC0AC\\uAC01\\uD615 239",
    width: 6,
    height: 20,
    rx: 3,
    transform: "translate(1286 847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_3",
    "data-name": "\\uBE7C\\uAE30 3",
    d: "M1622,3626h-60v-4a10.011,10.011,0,0,1,10-10h40a10.011,10.011,0,0,1,10,10v4Zm-8.5-9a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,1613.5,3617Zm-8,0a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,1605.5,3617Zm-8,0a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,1597.5,3617Z",
    transform: "translate(-314 -2783)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.a8fca081e0a299bae26aa2ee98086c53.svg";
export { ForwardRef as ReactComponent };